<template>
    <div>
        <h6 class="">{{ $t(`${configId}.notifications.title`) }}</h6>
        <hr class="mt-2" />
        <div class="row">
            <div class="col-sm-4">
                <MaterialSelect
                    :disabled="disabled"
                    class="city-form-group city-bg"
                    id="input-notifications"
                    name="notifications"
                    label="name"
                    :filterable="true"
                    :options="lists.onoff"
                    v-model.trim="form.status"
                    :reduce="option => option.code"
                    :data-vv-scope="vScope"
                    v-validate="'required'"
                    :inputClasses="[{'is-invalid': fnHasError('notifications', vScope) }]"
                    :error=" fnFirstError('notifications', vScope)"
                    :helpText="helpNotifications.status">
                    {{ $t(`${configId}.notifications.model.status`) }}
                </MaterialSelect>
            </div>
        </div>
    </div>
</template>

<script>
import ManagePrintElementMixin from '../mixins/ManagePrintElementMixin';

export default {
    name: 'ConfigNotificationsGeneral',
    mixins: [
        ManagePrintElementMixin,
    ],
    props: {
        notificationsHelp: {
            type: Object,
        },
    },
    data() {
        return {
            form: {
                status: 0,
                channel: 'mail',
            },
        }
    },
    computed: {
        helpNotifications() {
            return this.notificationsHelp ?? this.$t(`${this.configId}.notifications.help`);
        },
    },
}
</script>
